// extracted by mini-css-extract-plugin
export default {"innerWrapper":"bu-z","tooltipWrapper":"cu-z","icon":"du-z","tooltip":"eu-z","content":"fu-z"};